import vtkEllipseWidget from './EllipseWidget';
import vtkImageCroppingWidget from './ImageCroppingWidget';
import vtkImplicitPlaneWidget from './ImplicitPlaneWidget';
import vtkInteractiveOrientationWidget from './InteractiveOrientationWidget';
import vtkPaintWidget from './PaintWidget';
import vtkPolyLineWidget from './PolyLineWidget';
import vtkRectangleWidget from './RectangleWidget';
import vtkResliceCursorWidget from './ResliceCursorWidget';

export default {
  vtkEllipseWidget,
  vtkImageCroppingWidget,
  vtkImplicitPlaneWidget,
  vtkInteractiveOrientationWidget,
  vtkPaintWidget,
  vtkPolyLineWidget,
  vtkRectangleWidget,
  vtkResliceCursorWidget,
};
